import { Rotate } from './Rotate';
import { Filters } from './Filters';
import { Zoom } from './Zoom';
import { Measurement } from './Measurement';
import {
  ControlsContainer,
  ButtonContainer,
  ThumbnailControlsContainer,
  ThumbnailButtonContainer,
} from './Controls.style';
import { ImageProps } from '../Image';
import { PictureTarget } from 'horizon/routes/Inspections/types';
import { isRotationEnabled } from '../utils';

type ControlsProps = {
  onChange: (arg: any) => void;
  onClickLevels: () => void;
  value?: {
    rotate?: boolean;
    filter?: string;
    levels?: { url?: string; width?: number; height?: number; a?: number; b?: number };
    measure?: boolean;
    edit?: boolean;
  };
  target?: PictureTarget;
  isThumbnail?: boolean;
  pictureId?: string;
  pictureGlobalId?: string;
  refetch: ImageProps['refetch'];
  hasHomography?: boolean;
};

export const Controls: React.FunctionComponent<ControlsProps> = ({
  onChange,
  onClickLevels,
  value,
  target,
  isThumbnail = false,
  pictureId,
  pictureGlobalId,
  refetch,
  hasHomography = false,
}) => {
  const { rotate, filter, levels, measure, edit } = value ?? {};

  // enable rotation for external/internal blades that have a bladeAngle different from 0rad
  const rotationEnabled = isRotationEnabled(target);

  if (isThumbnail) {
    return (
      <ThumbnailControlsContainer>
        <ThumbnailButtonContainer>
          <Zoom onChange={onChange} />
        </ThumbnailButtonContainer>
        <ThumbnailButtonContainer>
          <Rotate onChange={onChange} value={rotate} disabled={!rotationEnabled} />
        </ThumbnailButtonContainer>
      </ThumbnailControlsContainer>
    );
  }

  return (
    <ControlsContainer>
      {measure !== undefined && (
        <ButtonContainer>
          <Measurement
            onChange={onChange}
            value={measure}
            disabled={edit}
            hasHomography={hasHomography}
          />
        </ButtonContainer>
      )}
      <ButtonContainer>
        <Rotate onChange={onChange} value={rotate} disabled={!rotationEnabled} />
      </ButtonContainer>
      <ButtonContainer>
        <Filters
          onChange={onChange}
          onClickLevels={onClickLevels}
          value={filter}
          levels={levels}
          pictureId={pictureId}
          pictureGlobalId={pictureGlobalId}
          refetch={refetch}
        />
      </ButtonContainer>
      <ButtonContainer>
        <Zoom onChange={onChange} />
      </ButtonContainer>
    </ControlsContainer>
  );
};
